export default {
    "REGION": "us-east-1",
    "USER_POOL_ID": "us-east-1_bl4tYqYXT",
    "USER_POOL_APP_CLIENT_ID": "50u7teb5uoidl9t9u7at347uq"
}
